<template>
  <div class="view-visitor-info-wrapper">
    <div
      class="view-visitor-info-min"
    >
      <div class="visitor-info-header">
        <BaseIcon
          name="BadgeIcon"
          fill="#1E6FF1"
        />
        <p :style="{ ...getFontSizeForChatInterface('bodyText') }">
          Visitor info
        </p>
      </div>
      <div class="btn-grp">
        <div @click="handleEditVisitorInfo">
          <BaseIcon
            name="EditIcon"
            fill="#1C1F2A"
          />
        </div>
        <div @click="handleDeleteVisitorInfo">
          <BaseIcon
            name="DeleteIcon"
            fill="#6B6D7C"
          />
        </div>
        <div @click="handleToggleMaxMinVisitorInfo">
          <BaseIcon
            v-if="isMaximized"
            name="ArrowBackIcon"
            fill="#6B6D7C"
            height="16"
          />
          <BaseIcon
            v-else
            name="ArrowForwardIcon"
            fill="#6B6D7C"
            height="16"
          />
        </div>
      </div>
    </div>
    <div
      v-if="isMaximized"
      class="visitor-details"
    >
      <pre :style="{ ...getFontSizeForChatInterface('smallBodyText') }">{{ visitorInfoDetails }}</pre>
    </div>
  </div>
</template>
   
<script>

import BaseIcon from '@/views/BaseIcon.vue';
import { showMessageSeparatorPill } from '@/services/utils'
import fontSizeMixin from '@/mixins/fontSizeMixin'

export default {
  name: 'ViewVisitorInfo',
  components: {
    BaseIcon
  },
  mixins: [fontSizeMixin],
  data () {
    return {
      isMaximized: false
    }
  },
  computed: {
    visitorInfoDetails () {
      return JSON.stringify(this.$store.state.visitorInfoForm.visitorInfoDetails, null, 2)
    }
  },

  methods: {
    handleEditVisitorInfo () {
      this.$store.dispatch('showVisitorInfoForm', true)
    },
    handleDeleteVisitorInfo () {
      this.$store.dispatch('updateVisitorInfoForm', '');
      showMessageSeparatorPill({
        message: "Visitor information discarded",
        isEndChatSeparator: false
      })
    },
    handleToggleMaxMinVisitorInfo () {
      this.isMaximized = !this.isMaximized
    }
  }
}
</script>
<style lang="scss" scoped>
.view-visitor-info-wrapper {
  border-bottom: 1px solid #8BB5F8;
  background: #F0F5FE;
  padding: 6px 10px;
  max-height: 50%;
  overflow: auto;

  .view-visitor-info-min {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;

    .visitor-info-header {
      display: flex;
      align-items: center;
      gap: 16px;

      p {
        font-weight: 600;
      }
    }
    .btn-grp {
      display: flex;
      gap: 16px;
    }
  }

  .visitor-details {
    margin-left: 34px;

    pre {
      max-width: 100%;
      word-wrap: break-word;
    }
  }

}
</style>

   